{
  "SESSION_LIMIT": {
    "TITLE": "Active session limit reached",
    "DESCRIPTION": "You have reached your limit of active sessions. Please end a session before logging in.",
    "END": "End",
    "END_ALL": "End all sessions",
    "LOG_IN": "Log in",
    "CANCEL": "Back to login",
    "UNKNOWN_DEVICE": "Unknown device",
    "STARTED": "Started"
  }
}
